"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const General_1 = require("../../types/General");
const buildCallableHttpRequest = (axios) => async ({ entryVars, callbacks, executeProcesses, functionId, }) => {
    const executeError = (error) => {
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.CATCH], error);
    };
    const url = entryVars[General_1.DEFINITION_PROP_NAMES.URL];
    const method = entryVars[General_1.DEFINITION_PROP_NAMES.METHOD];
    const queryParams = entryVars[General_1.DEFINITION_PROP_NAMES.QUERY_PARAMS];
    const data = entryVars[General_1.DEFINITION_PROP_NAMES.DATA];
    const headers = entryVars[General_1.DEFINITION_PROP_NAMES.HEADERS];
    if (!(0, ts_validators_1.valueIsString)(url)) {
        executeError('Validation: Ulr is not a string');
        return;
    }
    const methodsMap = {
        [General_1.DEFINITION_PROP_NAMES.GET]: 'get',
        [General_1.DEFINITION_PROP_NAMES.POST]: 'post',
        [General_1.DEFINITION_PROP_NAMES.HEAD]: 'head',
        [General_1.DEFINITION_PROP_NAMES.PUT]: 'put',
        [General_1.DEFINITION_PROP_NAMES.PATCH]: 'patch',
        [General_1.DEFINITION_PROP_NAMES.DELETE]: 'delete',
        [General_1.DEFINITION_PROP_NAMES.PURGE]: 'purge',
        [General_1.DEFINITION_PROP_NAMES.LINK]: 'link',
        [General_1.DEFINITION_PROP_NAMES.UNLINK]: 'unlink',
    };
    if (method !== General_1.DEFINITION_PROP_NAMES.GET
        && method !== General_1.DEFINITION_PROP_NAMES.POST
        && method !== General_1.DEFINITION_PROP_NAMES.HEAD
        && method !== General_1.DEFINITION_PROP_NAMES.PUT
        && method !== General_1.DEFINITION_PROP_NAMES.PATCH
        && method !== General_1.DEFINITION_PROP_NAMES.DELETE
        && method !== General_1.DEFINITION_PROP_NAMES.PURGE
        && method !== General_1.DEFINITION_PROP_NAMES.LINK
        && method !== General_1.DEFINITION_PROP_NAMES.UNLINK) {
        executeError(`Validation: Method is invalid: ${method}`);
        return;
    }
    if (queryParams !== undefined && !(0, ts_validators_1.valueIsRecord)(queryParams)) {
        executeError('Validation: Query params is not a record');
        return;
    }
    if (data !== undefined
        && !(0, ts_validators_1.valueIsRecord)(data)
        && !(0, ts_validators_1.valueIsString)(data)) {
        executeError('Validation: Data is not a record or an string');
        return;
    }
    const valueIsHeaders = (0, ts_validators_1.buildValueIsRecordOf)((0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsString,
        ts_validators_1.valueIsNumber,
        ts_validators_1.valueIsBoolean,
    ]));
    if (headers !== undefined && !valueIsHeaders(headers)) {
        executeError('Validation: Headers is not a record of string, number or boolean');
        return;
    }
    try {
        const response = await axios({
            url,
            method: methodsMap[method],
            params: queryParams,
            data,
            headers,
        });
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.THEN], response);
    }
    catch (error) {
        const errorResponse = (0, getValueByPathFromUnknown_1.default)(error, ['response']);
        executeError(errorResponse);
    }
};
exports.default = buildCallableHttpRequest;
